import { ITrackingResponse } from "@swyft/swyft-common";
import { AddCircle } from "@helo/ui/icons";
import { Box, Grid, Link, styled, Typography } from "@helo/ui";

import { openWebWidget } from "~/helpers/frontapp";

interface InfoCardProps {
  data: ITrackingResponse;
}

const AddDeliveryInstrTrigger = styled(Link)(({ theme }) => ({
  padding: "24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: theme.palette.primaryScale[900],
  },
}));

const InfoCard = (props: InfoCardProps) => {
  const { data } = props;

  return (
    <div className="info-card">
      <Grid container className="info-card__item">
        <Grid item xs={12} sm={6} sx={{ textAlign: "left", padding: 3 }}>
          <Typography variant="h5" component="h4" fontWeight={600}>
            {data.businessName}
          </Typography>
          <Typography
            sx={({ palette }) => ({ color: palette.neutralScale[500] })}
          >
            <span className="city">{data.originCity},</span>
            <span className="country"> {data.originProvince}</span>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} sx={{ textAlign: "right", padding: 3 }}>
          <Typography variant="h5" component="h4" fontWeight={600}>
            {data.shortName}
          </Typography>
          <Typography
            sx={({ palette }) => ({ color: palette.neutralScale[500] })}
          >
            <span className="city">{data.destinationCity},</span>
            <span className="country"> {data.destinationProvince}</span>
          </Typography>
        </Grid>
      </Grid>
      <Box>
        <AddDeliveryInstrTrigger onClick={openWebWidget}>
          <AddCircle style={{ marginRight: 16 }} />
          <Typography
            variant="subtitle1"
            component="p"
            sx={({ palette }) => ({
              color: palette.primary.dark,
              textTransform: "uppercase",
              fontWeight: 700,
            })}
          >
            Add Delivery Instructions
          </Typography>
        </AddDeliveryInstrTrigger>
      </Box>
    </div>
  );
};

export default InfoCard;
